import { render, staticRenderFns } from "./user-access-input.vue?vue&type=template&id=62f50959"
import script from "./user-access-input.vue?vue&type=script&lang=js"
export * from "./user-access-input.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports